module.exports = {
    NODE_ENV : "production",
    API : "/cloud-api"
}